<div class="accessibility-panel" [class.open]="isOpen">

  <!-- Panel Content -->
  <div class="accessibility--content" *ngIf="isOpen">
    <div class="panel--header">
      <h3 class="panel--title">Accessibility Options</h3>
      <button class="panel--close" (click)="close()" aria-label="Close accessibility options">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <ul class="options--list">
      <!-- Increase Text -->
      <li class="option--item">
        <button class="option--button" (click)="increaseText()" [disabled]="!canIncreaseText">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M11 8V14M8 11H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Increase Text</span>
        </button>
      </li>

      <!-- Decrease Text -->
      <li class="option--item">
        <button class="option--button" (click)="decreaseText()" [disabled]="!canDecreaseText">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="2"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M8 11H14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Decrease Text</span>
        </button>
      </li>

      <!-- Grayscale -->
      <li class="option--item">
        <button class="option--button" (click)="toggleGrayscale()" [class.active]="settings.grayscale">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22V2Z" fill="currentColor"/>
          </svg>
          <span>Grayscale</span>
        </button>
      </li>

      <!-- High Contrast -->
      <li class="option--item">
        <button class="option--button" (click)="toggleHighContrast()" [class.active]="settings.highContrast">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" stroke="currentColor" stroke-width="2" fill="currentColor"/>
            <rect x="7" y="7" width="10" height="10" fill="white"/>
          </svg>
          <span>High Contrast</span>
        </button>
      </li>

      <!-- Negative Contrast -->
      <li class="option--item">
        <button class="option--button" (click)="toggleNegativeContrast()" [class.active]="settings.negativeContrast">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" fill="white" stroke="currentColor" stroke-width="2"/>
            <rect x="7" y="7" width="10" height="10" fill="currentColor"/>
          </svg>
          <span>Negative Contrast</span>
        </button>
      </li>

      <!-- Light Background -->
      <li class="option--item">
        <button class="option--button" (click)="toggleLightBackground()" [class.active]="settings.lightBackground">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="5" stroke="currentColor" stroke-width="2"/>
            <path d="M12 1V3M12 21V23M23 12H21M3 12H1M20.66 20.66L19.25 19.25M4.75 4.75L3.34 3.34M20.66 3.34L19.25 4.75M4.75 19.25L3.34 20.66" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Light Background</span>
        </button>
      </li>

      <!-- Links Underline -->
      <li class="option--item">
        <button class="option--button" (click)="toggleLinksUnderline()" [class.active]="settings.linksUnderline">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M10 13C10.4295 13.5741 10.9774 14.0492 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0435 15.0796 14.9404 15.7513 14.6897C16.4231 14.4391 17.0331 14.0467 17.54 13.54L20.54 10.54C21.4508 9.59699 21.9548 8.33397 21.9434 7.02299C21.932 5.71201 21.4061 4.45794 20.4791 3.5309C19.5521 2.60386 18.298 2.07802 16.987 2.06663C15.676 2.05524 14.413 2.55924 13.47 3.47L11.75 5.18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 11C13.5705 10.4259 13.0226 9.95083 12.3934 9.60707C11.7643 9.26331 11.0685 9.05889 10.3533 9.00768C9.63816 8.95646 8.92037 9.05961 8.24861 9.31028C7.57685 9.56095 6.9669 9.95334 6.46 10.46L3.46 13.46C2.54924 14.403 2.04524 15.666 2.05663 16.977C2.06802 18.288 2.59386 19.5421 3.5209 20.4691C4.44794 21.3961 5.70201 21.922 7.01299 21.9334C8.32397 21.9448 9.58699 21.4408 10.53 20.53L12.24 18.82" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Links Underline</span>
        </button>
      </li>

      <!-- Readable Font -->
      <li class="option--item">
        <button class="option--button" (click)="toggleReadableFont()" [class.active]="settings.readableFont">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="2"/>
            <path d="M8 8H16M8 12H16M8 16H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Readable Font</span>
        </button>
      </li>

      <!-- Reset -->
      <li class="option--item option--reset">
        <button class="option--button reset--button" (click)="reset()">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M20.49 9C19.9828 7.56678 19.1209 6.28536 17.9845 5.27542C16.8482 4.26548 15.4745 3.55976 13.9917 3.22426C12.5089 2.88875 10.9652 2.93434 9.50481 3.35677C8.04437 3.77921 6.71475 4.56471 5.64 5.64L1 10M23 14L18.36 18.36C17.2853 19.4353 15.9556 20.2208 14.4952 20.6432C13.0348 21.0657 11.4911 21.1112 10.0083 20.7757C8.52547 20.4402 7.1518 19.7345 6.01547 18.7246C4.87913 17.7146 4.01717 16.4332 3.51 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span>Reset</span>
        </button>
      </li>
    </ul>
  </div>

  <!-- Overlay -->
  <div class="accessibility--overlay" *ngIf="isOpen" (click)="close()"></div>
</div>

